import React from "react"

import { TAuthor } from "@/types/author"

import InsightsAvatar from "./insights/InsightsAvatar"

interface PostMetaProps {
  author?: TAuthor
  title: string
  date: string
  authors?: TAuthor[]
}
const PostMeta: React.FC<PostMetaProps> = ({
  title,
  date,
  authors,
  author,
}) => {
  const authorName = author?.firstName
    ? `${author?.firstName} ${author?.lastName}`
    : "Team Ripple"
  return (
    <div>
      <h1
        className="mt-12 headline5 md:headline4 !text-gray-2.5"
        itemProp="headline"
      >
        <span>{title}</span>
      </h1>

      <div
        className="flex items-center my-8 gap-3"
        itemProp="author"
        itemScope
        itemType="http://schema.org/Person"
      >
        {authors?.length ? (
          authors?.map((person) => (
            <div key={person?.firstName} className="flex items-center gap-2">
              <InsightsAvatar
                author={`${person?.firstName} ${person?.lastName}`}
              />
              <p className="body3 !text-gray-2.5 !mb-0" itemProp="name">
                {`${person?.firstName} ${person?.lastName}`}
              </p>
            </div>
          ))
        ) : (
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 mr-1 overflow-hidden rounded-full">
              <InsightsAvatar author={authorName} />
            </div>
            <p className="body3 !text-gray-2.5 !mb-0" itemProp="name">
              {authorName || "Team Ripple"}
            </p>
          </div>
        )}
      </div>

      {date && (
        <div
          className="justify-end mt-8 caption2 text-gray-30"
          itemProp="datePublished"
        >
          {date}
        </div>
      )}
    </div>
  )
}
export default PostMeta
